import { CustomLogger } from '../engine/log/custom-logger';
import { CustomLogDecorator } from '../engine/log/custom-log-from-decorator';

export function Log(params?: { ignore?: boolean }): MethodDecorator {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      const result = originalMethod.apply(this, args);
      if (params && params.ignore === true) {
        return result;
      }
      CustomLogger.v(
        new CustomLogDecorator({
          target: target,
          method: propertyKey,
          args: args,
          result: result,
        })
      );
      return result;
    };
    return descriptor;
  };
}
